import {
  DailymotionPlatform,
  DemoPlatform,
  FacebookPlatform,
  InstagramPlatform,
  SocialPlatform,
  TikTokPlatform,
  TwitterPlatform,
  YoutubePlatform,
} from '@app/modules/social-export/domain/platforms';
import { useDailymotionExport } from '@app/modules/social-export/platforms/dailymotion/useDailymotionExport';
import { useDemoExport } from '@app/modules/social-export/platforms/demo/useDemoExport';
import { useFacebookExport } from '@app/modules/social-export/platforms/facebook/useFacebookExport';
import { useInstagramExport } from '@app/modules/social-export/platforms/instagram/useInstagramExport';
import { useTwitterExport } from '@app/modules/social-export/platforms/twitter/useTwitterExport';
import { useYoutubeExport } from '@app/modules/social-export/platforms/youtube/useYoutubeExport';
import { GetFragmentDto } from '@mi-front/core';
import { ComponentType, ReactNode } from 'react';
import { useTikTokExport } from '../platforms/tiktok/useTiktokExport';

export interface BaseExportFormProps<Data, Settings> {
  fragment: GetFragmentDto;
  videoUrl: string;
  onUpload: (data: Data) => Promise<void>;
  defaultSettings: Settings;
  /** Actions slot (e.g. separator + submit/cancel). Rendered inside the form so FormActionsMui has form context. */
  actions?: ReactNode;
}

export interface BaseSettingsFormProps<Data> {
  stationId: string;
  onUpdate: (data: Data) => Promise<void>;
  defaultSettings: Data;
}

export type ExportFormHook<Data, Settings> = () => {
  PublishForm: ComponentType<BaseExportFormProps<Data, Settings>>;
  SettingsForm: ComponentType<BaseSettingsFormProps<Settings>>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic form props vary by platform
export function useSocialExportFactory(platform: SocialPlatform): ExportFormHook<any, any> {
  if (platform === FacebookPlatform) {
    return useFacebookExport;
  }

  if (platform === InstagramPlatform) {
    return useInstagramExport;
  }

  if (platform === TwitterPlatform) {
    return useTwitterExport;
  }

  if (platform === DailymotionPlatform) {
    return useDailymotionExport;
  }

  if (platform === DemoPlatform) {
    return useDemoExport;
  }

  if (platform === YoutubePlatform) {
    return useYoutubeExport;
  }

  if (platform === TikTokPlatform) {
    return useTikTokExport;
  }

  throw new Error(`Platform ${platform.id} not implemented!`);
}
